import React, { useRef, useState } from "react";
import GlobalState from "../../../stores/GlobalState";
import lang from "../../../lang";

export default function AttachmentBox({ attachments, setAttachments, setLoad }) {
  const sizeInMB = (sizeInBytes) => (sizeInBytes / (1024 * 1024 * 100)).toFixed(2);

  const [langmenu] = useState(localStorage.getItem("lang_site") || "en");
  const [langv] = useState(langmenu === "de" ? lang.de : lang.en);

  const inputRef = useRef(null);

  const handleFiles = (fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;

    setLoad(1);

    const filesToUpload = files.map((file) => {
      const fileExtension = file.name.split(".").pop();
      const fileName = file.name;
      const fileSize = sizeInMB(file.size);

      return {
        file_extension: fileExtension,
        file_name: fileName,
        file_path: fileName,
        file_size: fileSize,
        file_type: 2,
        file,
      };
    });

    if (filesToUpload.length > 0) {
      setAttachments(filesToUpload);
      setLoad(3);
    } else {
      setLoad(4);
    }
  };

  const handleInputChange = (e) => {
    handleFiles(e.target.files);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer?.files?.length) {
      handleFiles(e.dataTransfer.files);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const openFileDialog = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  return (
    <div className="my-14 px-10 zeras">
      <div
        className="min-h-88 flex items-center justify-center cursor-pointer border_drop"
        onClick={openFileDialog}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        {dropzoneText(langv)}
      </div>

      <input
        ref={inputRef}
        type="file"
        accept=".csv"
        style={{ display: "none" }}
        onChange={handleInputChange}
      />
    </div>
  );
}

// той самий контент, що був у dropzoneText
function dropzoneText(langv) {
  const t = langv?.dataset?.popupadddataset || {};

  return (
    <>
     

      <div className="text-center my-16 dropanddrag">
        <div className="uploadiconline">
          <div className="uploadicon">
            <FileIcon />
          </div>
        </div>
        
        <div className="title_dropanddrag"  >
        {GlobalState.ispopupaddAttachmentShowbigdata==2 ? langv?.dataset?.popupadddataset?.text4: langv?.dataset?.popupadddataset?.text5}
        </div>
        <p className="text_dropanddrag">
          {langv?.dataset?.popupadddataset?.text6}
        </p>
        <div className="buttom_dropanddrag_line">
          <div className="buttom_dropanddrag" >{GlobalState.ispopupaddAttachmentShowbigdata==2 ?langv?.dataset?.popupadddataset?.text7: langv?.dataset?.popupadddataset?.text8}</div>
        </div>
        
      </div>
    </>
  );
}

const FileIcon = () => (
  <>
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.9992 0.642365L9.89062 9.64347L11.9106 11.4722L18.5706 5.5435V27.5439H21.4278V5.5435L28.0849 11.4696L30.1078 9.64347L19.9992 0.642365Z" fill="#F5C538"/>
      <path d="M0 38.1002V40.6436H2.85714H20H37.1429H40V38.1002H0Z" fill="#F5C538"/>
    </svg>

  </>
);
